export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './device.service';
import { DeviceService } from './device.service';
export * from './firmware.service';
import { FirmwareService } from './firmware.service';
export * from './groups.service';
import { GroupsService } from './groups.service';
export * from './location.service';
import { LocationService } from './location.service';
export * from './mender.service';
import { MenderService } from './mender.service';
export * from './redis.service';
import { RedisService } from './redis.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './xPACMobileTooling.service';
import { XPACMobileToolingService } from './xPACMobileTooling.service';
export const APIS = [AuthenticationService, DeviceService, FirmwareService, GroupsService, LocationService, MenderService, RedisService, UsersService, XPACMobileToolingService];
